<div>
  @if (customTrigger()) {
    <ng-content select="[vDropdownTrigger]"></ng-content>
  } @else if (appearance() === 'plain') {
    <button
      type="button"
      class="w-8 h-8 rounded-lg flex items-center justify-center text-subtle hover:text-primary hover:bg-surface-2 transition-colors cursor-pointer"
      (click)="pom.toggle($event)">
      <i [class]="icon()"></i>
    </button>
  } @else {
    <v-icon-button
      size="small"
      variant="secondary"
      icon="{{ icon() }} mt-0.5"
      (press)="pom.toggle($event)"></v-icon-button>
  }

  <p-popover #pom [dismissable]="true">
    <v-menu [items]="menuItemsWithCloseHandler()" size="small"></v-menu>
  </p-popover>
</div>
